export const generateRequiredErrorMessage = (fieldName) => {
  return `${fieldName} is required`;
};
export const validateFormData = (data, requiredFields) => {
  const errors = {};

  requiredFields.forEach((fieldName) => {
    if (!data[fieldName]) {
      errors[fieldName] = generateRequiredErrorMessage(fieldName);
    }
  });

  return errors;
};
